/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Reviews_Allreviews2Inputs */

const id_offerdetail_reviews_allreviews2 = /** @type {(inputs: Offerdetail_Reviews_Allreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua Ulasan`)
};

const ms_offerdetail_reviews_allreviews2 = /** @type {(inputs: Offerdetail_Reviews_Allreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua Ulasan`)
};

const da_offerdetail_reviews_allreviews2 = /** @type {(inputs: Offerdetail_Reviews_Allreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Anmeldelser`)
};

const de_offerdetail_reviews_allreviews2 = /** @type {(inputs: Offerdetail_Reviews_Allreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Bewertungen`)
};

const en_us2_offerdetail_reviews_allreviews2 = /** @type {(inputs: Offerdetail_Reviews_Allreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Reviews`)
};

const es_es2_offerdetail_reviews_allreviews2 = /** @type {(inputs: Offerdetail_Reviews_Allreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas las reseñas`)
};

const es_mx2_offerdetail_reviews_allreviews2 = /** @type {(inputs: Offerdetail_Reviews_Allreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas las reseñas`)
};

const fil_offerdetail_reviews_allreviews2 = /** @type {(inputs: Offerdetail_Reviews_Allreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lahat ng Review`)
};

const fr_offerdetail_reviews_allreviews2 = /** @type {(inputs: Offerdetail_Reviews_Allreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous les avis`)
};

const it_offerdetail_reviews_allreviews2 = /** @type {(inputs: Offerdetail_Reviews_Allreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutte le recensioni`)
};

const hu_offerdetail_reviews_allreviews2 = /** @type {(inputs: Offerdetail_Reviews_Allreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minden értékelés`)
};

const nl_offerdetail_reviews_allreviews2 = /** @type {(inputs: Offerdetail_Reviews_Allreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle reviews`)
};

const no_offerdetail_reviews_allreviews2 = /** @type {(inputs: Offerdetail_Reviews_Allreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle omtaler`)
};

const pl_offerdetail_reviews_allreviews2 = /** @type {(inputs: Offerdetail_Reviews_Allreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszystkie recenzje`)
};

const pt_br2_offerdetail_reviews_allreviews2 = /** @type {(inputs: Offerdetail_Reviews_Allreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas as avaliações`)
};

const pt_offerdetail_reviews_allreviews2 = /** @type {(inputs: Offerdetail_Reviews_Allreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas as avaliações`)
};

const ro_offerdetail_reviews_allreviews2 = /** @type {(inputs: Offerdetail_Reviews_Allreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toate recenziile`)
};

const fi_offerdetail_reviews_allreviews2 = /** @type {(inputs: Offerdetail_Reviews_Allreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaikki arvostelut`)
};

const sv_offerdetail_reviews_allreviews2 = /** @type {(inputs: Offerdetail_Reviews_Allreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alla recensioner`)
};

const vi_offerdetail_reviews_allreviews2 = /** @type {(inputs: Offerdetail_Reviews_Allreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tất cả đánh giá`)
};

const tr_offerdetail_reviews_allreviews2 = /** @type {(inputs: Offerdetail_Reviews_Allreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüm Yorumlar`)
};

const cs_offerdetail_reviews_allreviews2 = /** @type {(inputs: Offerdetail_Reviews_Allreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Všechny recenze`)
};

const bg_offerdetail_reviews_allreviews2 = /** @type {(inputs: Offerdetail_Reviews_Allreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Всички ревюта`)
};

const ru_offerdetail_reviews_allreviews2 = /** @type {(inputs: Offerdetail_Reviews_Allreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все обзоры`)
};

const uk_offerdetail_reviews_allreviews2 = /** @type {(inputs: Offerdetail_Reviews_Allreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Усі відгуки`)
};

const ar_offerdetail_reviews_allreviews2 = /** @type {(inputs: Offerdetail_Reviews_Allreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جميع المراجعات`)
};

const hi_offerdetail_reviews_allreviews2 = /** @type {(inputs: Offerdetail_Reviews_Allreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी समीक्षाएँ`)
};

const th_offerdetail_reviews_allreviews2 = /** @type {(inputs: Offerdetail_Reviews_Allreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รีวิวทั้งหมด`)
};

const ja_offerdetail_reviews_allreviews2 = /** @type {(inputs: Offerdetail_Reviews_Allreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてのレビュー`)
};

const zh_cn2_offerdetail_reviews_allreviews2 = /** @type {(inputs: Offerdetail_Reviews_Allreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有评论`)
};

const zh_hant1_offerdetail_reviews_allreviews2 = /** @type {(inputs: Offerdetail_Reviews_Allreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有評論`)
};

const ko_offerdetail_reviews_allreviews2 = /** @type {(inputs: Offerdetail_Reviews_Allreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모든 리뷰`)
};

/**
* | output |
* | --- |
* | "All Reviews" |
*
* @param {Offerdetail_Reviews_Allreviews2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_reviews_allreviews2 = /** @type {((inputs?: Offerdetail_Reviews_Allreviews2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Reviews_Allreviews2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_reviews_allreviews2(inputs)
	if (locale === "ms") return ms_offerdetail_reviews_allreviews2(inputs)
	if (locale === "da") return da_offerdetail_reviews_allreviews2(inputs)
	if (locale === "de") return de_offerdetail_reviews_allreviews2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_reviews_allreviews2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_reviews_allreviews2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_reviews_allreviews2(inputs)
	if (locale === "fil") return fil_offerdetail_reviews_allreviews2(inputs)
	if (locale === "fr") return fr_offerdetail_reviews_allreviews2(inputs)
	if (locale === "it") return it_offerdetail_reviews_allreviews2(inputs)
	if (locale === "hu") return hu_offerdetail_reviews_allreviews2(inputs)
	if (locale === "nl") return nl_offerdetail_reviews_allreviews2(inputs)
	if (locale === "no") return no_offerdetail_reviews_allreviews2(inputs)
	if (locale === "pl") return pl_offerdetail_reviews_allreviews2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_reviews_allreviews2(inputs)
	if (locale === "pt") return pt_offerdetail_reviews_allreviews2(inputs)
	if (locale === "ro") return ro_offerdetail_reviews_allreviews2(inputs)
	if (locale === "fi") return fi_offerdetail_reviews_allreviews2(inputs)
	if (locale === "sv") return sv_offerdetail_reviews_allreviews2(inputs)
	if (locale === "vi") return vi_offerdetail_reviews_allreviews2(inputs)
	if (locale === "tr") return tr_offerdetail_reviews_allreviews2(inputs)
	if (locale === "cs") return cs_offerdetail_reviews_allreviews2(inputs)
	if (locale === "bg") return bg_offerdetail_reviews_allreviews2(inputs)
	if (locale === "ru") return ru_offerdetail_reviews_allreviews2(inputs)
	if (locale === "uk") return uk_offerdetail_reviews_allreviews2(inputs)
	if (locale === "ar") return ar_offerdetail_reviews_allreviews2(inputs)
	if (locale === "hi") return hi_offerdetail_reviews_allreviews2(inputs)
	if (locale === "th") return th_offerdetail_reviews_allreviews2(inputs)
	if (locale === "ja") return ja_offerdetail_reviews_allreviews2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_reviews_allreviews2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_reviews_allreviews2(inputs)
	return ko_offerdetail_reviews_allreviews2(inputs)
});
export { offerdetail_reviews_allreviews2 as "offerDetail.reviews.allReviews" }